import React from 'react';
import Hero from './components/Hero';
//import Navbar from './components/Navbar';
//import About from './components/About';
import Projects from './components/Projects';
//import Resume from './components/Resume';
import Footer from './components/Footer';
import { Analytics } from "@vercel/analytics/react";

import './App.css';

function App() {
    return (
        <>
            <Analytics />
            <Hero />
            {/* <Navbar /> */}
            <div className="main-bg">
            </div>
            {/* <About /> */}
            {/* <Resume /> */}
            <Projects />
            <Footer />
        </>
    );
}
//comments
export default App;